/** Shared helpers for Google Places address autocomplete */

export const ADDRESS_FIELDS = [
  'street',
  'street2',
  'city',
  'state',
  'postal_code',
  'country',
  'lat',
  'lon',
  'google_places_id',
  'formatted_address',
];

export const defaultAutocompleteOptions = {
  componentRestrictions: {
    country: ['us', 'ca'],
  },
  fields: [
    'address_components',
    'formatted_address',
    'geometry',
    'place_id',
    'utc_offset_minutes',
  ],
  types: ['address'],
};

export const formattedAddressFieldName = (name) => `${name}.formatted_address`;

export const loadGoogleMapsPlacesScript = (apiKey) => {
  return new Promise((resolve, reject) => {
    if (window.google?.maps?.places) {
      resolve();
      return;
    }

    const scriptSelector = 'script[data-google-maps-places]';
    const existingScript = document.querySelector(scriptSelector);

    if (existingScript) {
      if (window.google?.maps?.places) {
        resolve();
      } else {
        existingScript.addEventListener('load', () => resolve());
        existingScript.addEventListener('error', reject);
      }
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.dataset.googleMapsPlaces = 'true';
    script.onload = () => resolve();
    script.onerror = reject;
    document.body.appendChild(script);
  });
};

export const parsePlaceToAddressFields = (place) => {
  if (!place?.geometry?.location) {
    return null;
  }

  const hasStreetNumber = place.address_components?.some((component) =>
    component.types.includes('street_number'),
  );
  if (!hasStreetNumber) {
    alert('Please select a more specific address with a street number.');
    return null;
  }

  let streetNumber = '';
  let route = '';
  let street2 = '';
  let city = '';
  let state = '';
  let postal_code = '';
  let country = '';
  let localitySet = false;

  for (const component of place.address_components) {
    if (component.types.includes('postal_code')) {
      postal_code = component.long_name;
    }
    if (component.types.includes('street_number')) {
      streetNumber = component.long_name;
    }
    if (component.types.includes('route')) {
      route = component.long_name;
    }
    if (component.types.includes('subpremise')) {
      street2 = component.long_name;
    }

    if (component.types.includes('locality')) {
      city = component.long_name;
      localitySet = true;
    } else if (component.types.includes('sublocality') && !localitySet) {
      city = component.long_name;
      localitySet = true;
    } else if (
      component.types.includes('administrative_area_level_3') &&
      !localitySet
    ) {
      city = component.long_name;
      localitySet = true;
    }
    if (component.types.includes('administrative_area_level_1')) {
      state = component.short_name;
    }
    if (component.types.includes('country')) {
      country = component.short_name;
    }
  }

  const lat = place.geometry.location.lat();
  const lon = place.geometry.location.lng();

  return {
    street: `${streetNumber} ${route}`.trim(),
    street2,
    city,
    state,
    postal_code,
    country,
    lat,
    lon,
    google_places_id: place.place_id || '',
    formatted_address: place.formatted_address || '',
  };
};
